<div class="card-container"
  [class.no-padding]="disablePadding"
  [class.full-height]="fullHeight"
  [class.selected]="state === ProductState.INACTIVE"
  [class.pending]="state === ProductState.PENDING"
  [class.pending-termination]="state === ProductState.PENDING_TERMINATION"
  [class.active]="state === ProductState.ACTIVE"
  >
  @if (state) {
    <div class="label" [ngClass]="state">{{ ProductStateLabel[state] }}</div>
  }

  <div class="card-header">
    <ng-content select="[badge]"/>
    @if (header) {
      <span class="card-header-text">{{ header }}</span>
    }
    <ng-content select="[count-indicator]"></ng-content>
  </div>

  <div class="card-content">
    <ng-content></ng-content>
  </div>

  <div class="card-footer">
    <ng-content select="[button]"></ng-content>
  </div>

</div>
